import React, { FC, useState, useRef } from 'react';
import translate from '@translate';
import ProductsSelect from 'src/components/ProductsSelect';
import { checkFormValidity } from 'src/utils/formFunctions';
import TextField from 'src/components/TextField';
import Grid, { GridItem } from 'src/components/Grid';
import Button from 'src/components/Button';
import Typography from 'src/components/Typography';
import { colors, sizes } from 'src/themes/default';
import { EditKeysType } from './ProductsTable';
import { ProductSetProductType } from 'src/types/productSet';
import { FormErrorsType } from '../../types/global';

type NewProductBlockPropsType = {
    data?: ProductSetProductType[];
    onChange: (value: any) => void;
    disableEdit?: boolean;
    editErrors: FormErrorsType;
};

const initData: ProductSetProductType = {};

const NewProductBlock: FC<NewProductBlockPropsType> = (props) => {
    const formRef = useRef<HTMLFormElement>(null);

    const [editData, setEditData] = useState<ProductSetProductType>(initData);
    const [editErrors, setEditErrors] = useState<FormErrorsType>({});

    const changeValue = (key: EditKeysType, value: any, error: boolean) => {
        const newData = { ...editData };
        const newErrors = { ...editErrors };
        newData[key] = value;
        newErrors[key] = error;
        setEditData(newData);
        setEditErrors(newErrors);
    };

    const handleAddRow = () => {
        const newFormErrors = checkFormValidity(formRef);

        if (!Object.keys(newFormErrors).length) {
            const newId = Math.min.apply(0, [0, ...(props.data || []).map((item: any): any => item.ID)]) - 1;

            props.onChange([
                ...(props.data || []),
                {
                    ...editData,
                    ID: newId,
                },
            ]);

            setEditData(initData);
        }

        setEditErrors(newFormErrors);
    };

    return (
        <>
            <Typography gutterBottom variant="h3" sx={props.editErrors.PRODUCTS ? { color: colors.alert_O } : {}}>
                {translate('productSetDetail.action.addProduct')}
            </Typography>
            <form ref={formRef}>
                <Grid>
                    <GridItem cols={5}>
                        <ProductsSelect
                            value={editData.PRODUCT_SKU}
                            error={editErrors.PRODUCT_SKU}
                            idKey="SKU"
                            onChange={(value, error) => {
                                if (!Array.isArray(value)) {
                                    changeValue('PRODUCT_SKU', value?.SKU, error);
                                }
                            }}
                            name="PRODUCT_SKU"
                            label={translate('productSetDetail.productsTable.productSku')}
                            fullWidth
                            disabled={props.disableEdit}
                            required
                        />
                    </GridItem>
                    <GridItem cols={5}>
                        <TextField
                            value={editData.PRODUCT_COUNT}
                            error={editErrors.PRODUCT_COUNT}
                            onChange={(value, error) => changeValue('PRODUCT_COUNT', value, error)}
                            name="PRODUCT_COUNT"
                            label={translate('productSetDetail.productsTable.productCount')}
                            fullWidth
                            required
                            type="numberLocale"
                            min={1}
                            disabled={props.disableEdit}
                        />
                    </GridItem>
                    <GridItem cols={2}>
                        <Button
                            onClick={handleAddRow}
                            disabled={props.disableEdit}
                            sx={{ marginTop: sizes.input_top_PD }}
                            mobileFullWidht
                        >
                            + {translate('productSetDetail.productsTable.action.add')}
                        </Button>
                    </GridItem>
                </Grid>
            </form>
        </>
    );
};

export default NewProductBlock;
